import * as Apollo from '@apollo/client'
import {GQL_AllBoxesForStatsQuery, GQL_AllBoxesForStatsQueryVariables, useAllBoxesForStatsQuery} from '../../../generated/graphql'

export const useAllBoxesForStats = (baseOptions?: Apollo.QueryHookOptions<GQL_AllBoxesForStatsQuery, GQL_AllBoxesForStatsQueryVariables>) => {
  const {data, ...rest} = useAllBoxesForStatsQuery(baseOptions)
  return {
    ...rest,
    data:
      data?.box?.allBoxesForStats.map((box) => ({
        id: box.id,
        name: box.name,
        initialActivationTime: box.initialActivationTime ?? undefined,
        compartments: box.compartments.map((c) => ({id: c.id})),
      })) ?? [],
  }
}
